export const selectCreateJobError = state => state.jobs.createJobError;
export const selectCreateJobSuccessful =
  state => state.jobs.createJobSuccessful;
export const selectPendingJobs = state => state.jobs.pendingJobs;
export const selectUpdateJobError = state => state.jobs.updateJobError;
export const selectCompletedJobs = state => state.jobs.completedJobs;
export const selectPendingJobOffers = state => state.jobs.pendingJobOffers;
export const selectConfirmedJobs = state => state.jobs.confirmedJobs;
export const selectActiveJobs = state => state.jobs.activeJobs;
